import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["thumbnails"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createModule, MODULE_CONTROLLER, PLUGIN_FULLSCREEN, PLUGIN_THUMBNAILS } from "../../core/index.js";
import { ThumbnailsComponent } from "./ThumbnailsContainer.js";
export var defaultThumbnailsProps = {
  position: "bottom",
  width: 120,
  height: 80,
  border: 1,
  borderRadius: 4,
  padding: 4,
  gap: 16,
  imageFit: "contain",
  vignette: true
};
export var Thumbnails = function Thumbnails(_ref) {
  var augment = _ref.augment,
      contains = _ref.contains,
      append = _ref.append,
      addParent = _ref.addParent;
  augment(function (_ref2) {
    var thumbnails = _ref2.thumbnails,
        restProps = _objectWithoutProperties(_ref2, _excluded);

    return _objectSpread({
      thumbnails: _objectSpread(_objectSpread({}, defaultThumbnailsProps), thumbnails)
    }, restProps);
  });
  var module = createModule(PLUGIN_THUMBNAILS, ThumbnailsComponent);

  if (contains(PLUGIN_FULLSCREEN)) {
    append(PLUGIN_FULLSCREEN, module);
  } else {
    addParent(MODULE_CONTROLLER, module);
  }
};